/*
 * Potzillas — Inspirace lookbook
 * - Pill filter (vse / interier / exterier)
 * - JS masonry do sloupcu: kazda fotka jde do nejkratsiho sloupce (vyvazeny
 *   "Pinterest" stagger). "Nacist dalsi" jen PRIPOJI nove fotky na konec —
 *   uz zobrazene se NIKDY neprehazi (zadny skok nahoru).
 * - Fade-in reveal po scrollu
 *
 * Hotspoty / popovery resi sdileny potzillas-shoppable.js.
 */
(function () {
  function initLookbook(root) {
    if (!root || root.dataset.inspiraceReady === '1') return;
    root.dataset.inspiraceReady = '1';

    var grid = root.querySelector('[data-grid]');
    if (!grid) return;

    // reference na vsechny polozky (v poradi ze zdroje) — drzime je i kdyz
    // grid vyprazdnime pri prestavbe sloupcu
    var items = Array.prototype.slice.call(grid.querySelectorAll('[data-item]'));
    var pills = Array.prototype.slice.call(root.querySelectorAll('[data-filter]'));
    var moreBtn = root.querySelector('[data-load-more]');
    var moreWrap = moreBtn ? moreBtn.parentElement : null;

    var initialCount = parseInt(root.dataset.initialCount || '6', 10);
    if (isNaN(initialCount) || initialCount < 1) initialCount = 6;
    var step = parseInt(root.dataset.step || '', 10);
    if (isNaN(step) || step < 1) step = initialCount;

    var activeFilter = 'all';
    var targetShown = initialCount; // kolik fotek MA byt videt
    var shown = 0;                  // kolik uz je umisteno do sloupcu
    var columns = [];
    var colHeights = [];
    var colCount = 0;

    function matchesFilter(item) {
      return activeFilter === 'all' || item.dataset.category === activeFilter;
    }
    function currentFiltered() {
      return items.filter(matchesFilter);
    }
    // Odhad vysky z pomeru stran obrazku. Sloupce maji stejnou sirku, takze
    // pomer h/w staci k vyvazeni — a funguje i pred nactenim obrazku (atributy
    // width/height jsou v markupu), takze se nic nepreklada po dotnaceni.
    function estRatio(item) {
      var img = item.querySelector('img');
      if (!img) return 1;
      var w = parseFloat(img.getAttribute('width')) || 1;
      var h = parseFloat(img.getAttribute('height')) || 1;
      return h / w;
    }
    function computeColCount() {
      return window.matchMedia('(min-width: 750px)').matches ? 2 : 1;
    }
    function shortestCol() {
      var idx = 0;
      for (var i = 1; i < colHeights.length; i++) {
        if (colHeights[i] < colHeights[idx]) idx = i;
      }
      return idx;
    }

    // --- Reveal-on-scroll ---
    var io = ('IntersectionObserver' in window)
      ? new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              io.unobserve(entry.target);
            }
          });
        }, { threshold: 0.12 })
      : null;
    function revealObserve(item) {
      if (!io) { item.classList.add('is-visible'); return; }
      if (item.classList.contains('is-visible')) return;
      io.observe(item);
    }

    function buildColumns(n) {
      grid.textContent = ''; // odpoji vsechny polozky (drzime je v items[])
      columns = [];
      colHeights = [];
      for (var i = 0; i < n; i++) {
        var col = document.createElement('div');
        col.className = 'inspirace-lookbook__col';
        grid.appendChild(col);
        columns.push(col);
        colHeights.push(0);
      }
      colCount = n;
    }

    // umisti polozky filtered[from..to) do nejkratsich sloupcu (APPEND)
    function placeRange(filtered, from, to) {
      for (var i = from; i < to; i++) {
        var item = filtered[i];
        var idx = shortestCol();
        columns[idx].appendChild(item);
        colHeights[idx] += estRatio(item);
        item.hidden = false;
        revealObserve(item);
      }
    }

    function updateMore(filtered) {
      if (moreWrap) moreWrap.hidden = filtered.length <= shown;
    }

    // plny prepocet (init / zmena filtru / zmena poctu sloupcu)
    function fullLayout() {
      buildColumns(computeColCount());
      var filtered = currentFiltered();
      var to = Math.min(targetShown, filtered.length);
      placeRange(filtered, 0, to);
      shown = to;
      updateMore(filtered);
    }

    // nacist dalsi — pouze PRIPOJI nove polozky, nic neprehazuje
    function loadMore() {
      var filtered = currentFiltered();
      targetShown += step;
      var to = Math.min(targetShown, filtered.length);
      placeRange(filtered, shown, to);
      shown = to;
      updateMore(filtered);
    }

    function setFilter(value) {
      activeFilter = value;
      targetShown = initialCount;
      pills.forEach(function (p) {
        var isActive = p.dataset.filter === value;
        p.classList.toggle('is-active', isActive);
        p.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      fullLayout();
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () { setFilter(pill.dataset.filter); });
    });
    if (moreBtn) {
      moreBtn.addEventListener('click', loadMore);
    }

    // Prepocet jen kdyz se zmeni pocet sloupcu (mobil <-> desktop), aby
    // load-more nikdy nereshufloval uz zobrazene fotky.
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (computeColCount() !== colCount) fullLayout();
      }, 150);
    });

    fullLayout();
  }

  function initAll() {
    document.querySelectorAll('[data-lookbook]').forEach(initLookbook);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme editor podpora
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-lookbook]') || (e.target.matches && e.target.matches('[data-lookbook]') ? e.target : null);
    if (section) initLookbook(section);
  });
})();
